import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import GenericViewPanel from './../GenericViewPanel';
import DocumentList from '..//DocumenList';

import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import FolderIcon from '@material-ui/icons/Folder';
import SearchIcon from '@material-ui/icons/Search';

import { Grid } from '@material-ui/core';

import DocumentSearchDialog from '../DocumentSearchDialog';
import AddFolder from './AddFolder';

import { Attachment as AttachmentIcon } from '@material-ui/icons';

import {
  IconButton,
  Typography,
  LinearProgress,
  DialogTitle,
  Button,
  Fab,
  Input
} from '@material-ui/core';

import { useState, useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  addAttachmentFab: {
    marginRight:  theme.spacing(3),
  },
  fab: {
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
    width: 250,
    height: '36px !important',
    borderWidth: 1.3,
    flex: 1
  },
  extendedIcon:{
    marginRight:  theme.spacing(1),
  }
}));

const DocumentLibraryPanelForBranch = (props) => {
  const classes = useStyles();
  const {
    documents,
    allDocumentsForLibrary,
    currentDirectory,
    defaultDirectory,
    onShowFolderItems,
    onBackClicked,
    onReset,
    handleDocumentSelected,
    fetchAllDocumentsForLibrary,
    isLoading,
    branchId,
    onAddFolderDispatch
  } = props;

  React.useEffect(
    () => {
      fetchAllDocumentsForLibrary(branchId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const [open, setOpen] = useState(false);



  const handleFolderClick = (folder) => {
    onShowFolderItems(folder.documentName);
  };

  const handleDocumentClick = (document) => {
    window.open(document.blobFullUrl, '_blank', 'noopener,noreferrer');
  };


  const handleBackButtonClicked = (e) => {
    e.preventDefault();
    onBackClicked();
  };


  const handleSearchClosed = () => {
    setOpen(false);
  };
  

  //Attahchments

  
  const hiddenFileInput = React.createRef();
  
  const handleClick = (event) => {
    hiddenFileInput.current.children[0].click();
  };

  const onAttachmendAdded = (event) => {
    event.preventDefault();

    const {onAttachmentAdd} = props;

    const file = event.target.files[0];

    const payload = {branchId, attachments: file, currentDirectory, defaultDirectory}

    onAttachmentAdd(payload);

    /*onHandleInputChange(newObj, inputFieldNames.ACCIDENT_ATTACHMENT);*/

    hiddenFileInput.current.children[0].value = null;
  };

  const handleDeleteClick = (document) => {
   const {onAttachmentRemove} = props;
   const payload = {...document, branchId}
    onAttachmentRemove(payload);
  }


  //Add Folder props
  const [addFolderOpen, setFolderOpen] = useState(false);
  const [folderName, setFolderName] = useState("");
 
 
  const onHandleInputChange = (e, inputName) => {
    setFolderName(e);
  };

  const handleAddFolderClosed = () => {
    setFolderOpen(false);
  };
  
  const handleAddFolderSubmit = () => {
        onAddFolderDispatch(folderName);  
       setFolderOpen(false);
       setFolderName("");
  };

  const showBackBtn = currentDirectory === defaultDirectory + "branch-" + branchId + '/' ? false : true;

  return (
    <GenericViewPanel>
      {open && (
        <DocumentSearchDialog
          open={open}
          documents={allDocumentsForLibrary}
          handleSearchClosed={handleSearchClosed}
          handleDocumentClick={handleDocumentClick}
        />
      )}

      {addFolderOpen && 
      (<AddFolder     
        openDialog = {addFolderOpen}
        isSaving = {false}
        handleSubmit = {handleAddFolderSubmit}
        folderName = {folderName}
        onHandleInputChange = {onHandleInputChange}
        handleClose = {handleAddFolderClosed}
    />)}

      <div className={classes.actionBar}>
        <Grid container >
          <Grid xs={4} item>
            <DialogTitle
              id="alert-dialog-title"
              className={classes.dialogTitle}
            >
              Library
            </DialogTitle>
          </Grid>
         
          <Grid xs={8} item>
              <Fab
                 color="primary"
                 variant="extended"
                 aria-label="add"
                onClick={() => setFolderOpen(true)}
                className={`${classes.addAttachmentFab} ${classes.button}`}
              >
                 <FolderIcon className={classes.extendedIcon} />
                Add Folder
              </Fab>

              <Fab
                  id="addAttachmentBtn"
                  color="primary"
                  variant="extended"
                  aria-label="add"
                  onClick={handleClick}
                  className={`${classes.addAttachmentFab} ${classes.button}`}
                >
                  <AttachmentIcon className={classes.extendedIcon} />
                  Add attachment
                  <Input
                    type="file"
                    ref={hiddenFileInput}
                    multiple={false}
                    onChange={onAttachmendAdded}
                    style={{ display: 'none' }}
                  />
                </Fab>

                {documents && documents.length > 0 && (
              <Fab
                color="primary"
                variant="extended"
                onClick={() => setOpen(true)}
                className={`${classes.addAttachmentFab} ${classes.button}`}
              >
                 <SearchIcon className={classes.extendedIcon} />
                Search Documents
              </Fab>
            )}
          </Grid>
        </Grid>

        {isLoading ? <LinearProgress /> : ''}
        {!isLoading && (
          <Fragment>
            {showBackBtn ? (
              <div className={classes.backArrowContainer}>
                <IconButton
                  color="inherit"
                  onClick={handleBackButtonClicked}
                  id="settings-button"
                  className={classes.backArrow}
                >
                  <ArrowBackIcon color="primary" />
                </IconButton>
                <Typography className={classes.simpleLabel}>
                  {' '}
                  {currentDirectory}
                </Typography>
              </div>
            ) : (
              <div className={classes.backArrowContainer}>
                <Typography className={classes.simpleLabel}>
                  {' '}
                  {currentDirectory}
                </Typography>
              </div>
            )}
            {documents && (
              <DocumentList
                documents={documents}
                handleFolderClick={handleFolderClick}
                handleDocumentClick={handleDocumentClick}
                handleDeleteClick={handleDeleteClick}
                showDelete = {true}
              />
            )}
          </Fragment>
        )}
      </div>
    </GenericViewPanel>
  );
};

export default DocumentLibraryPanelForBranch;
